export enum QUESTION_TYPE {
  yes_no = 'yes/no',
  star_rating = 'star rating',
  number_rating = 'number_rating',
  user_input = 'user_input',
}
